import type { Eip1193Provider } from "ethers";
import { BaseWalletAdapter } from "./BaseWalletAdapter";

export class RabbyAdapter extends BaseWalletAdapter {
  readonly name = "rabby";

  get installed(): boolean {
    return Boolean(this.resolveProvider());
  }

  protected resolveProvider(): Eip1193Provider | undefined {
    if (typeof window === "undefined") return undefined;
    const win = window as any;
    if (win.ethereum?.providers?.length) {
      const found = win.ethereum.providers.find((p: any) => p?.isRabby);
      if (found) return found;
    }
    if (win.ethereum?.isRabby) return win.ethereum;
    if (win.rabby) return win.rabby;
    return undefined;
  }
}
